import { render, staticRenderFns } from "./NavTags.vue?vue&type=template&id=e47aeac8&scoped=true&"
import script from "./NavTags.vue?vue&type=script&lang=js&"
export * from "./NavTags.vue?vue&type=script&lang=js&"
import style0 from "./NavTags.vue?vue&type=style&index=0&id=e47aeac8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47aeac8",
  null
  
)

export default component.exports